<template>
  <div>
    <span>{{ v.actualPricePerShare | formatPrice }}</span>
    <div class="range-wrapper">
      <span>{{ v.predictionLow | formatPrice }}</span>
      <input
        type="range"
        :min="v.predictionLow"
        :max="v.predictionHigh"
        :value="v.actualPricePerShare"
        disabled="disabled"
        class="disabled"
        step="0.001"
      />
      <span>{{ v.predictionHigh | formatPrice }}</span>
    </div>
    <div class="range-wrapper">
      <span>{{ v.priorLow | formatPrice }}</span>
      <input
        type="range"
        :min="v.priorLow"
        :max="v.priorHigh"
        :value="v.actualPricePerShare"
        disabled="disabled"
        class="disabled"
        step="0.001"
      />
      <span>{{ v.priorHigh | formatPrice }}</span>
    </div>
  </div>
</template>
<script >
import vue from "vue";

export default vue.extend({
  template: "#range-template",
  components: {},
  props: {
    v: { type: Object },
  },
  data() {
    return {
      provider: {
        context: null,
      },
    };
  },
  provide() {
    return {
      provider: this.provider,
    };
  },
});
</script>